import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DemographicDataService {
  private demographicDataSubject = new BehaviorSubject<any>({
    demographics: null,
    regionType: 'DRIVE_TIME',
    regionValue: '7 minutes'
  });
  public demographicData$ = this.demographicDataSubject.asObservable();

  updateDemographicData(data: any): void {
    this.demographicDataSubject.next(data);
  }

  getDemographicData(): any {
    return this.demographicDataSubject.value;
  }
}